<template>
<div class="chapter">
<div class="inner_page">
<div class="titlepage">
<p class="center"><span class="big">Miracle</span><br/><span class="big1"><em><strong>in the</strong></em></span><br/><span class="big">Mine</span><br/><br/></p>
<p class="center">O<span class="small">NE</span> M<span class="small">AN’S</span> S<span class="small">TORY OF</span><br/>S<span class="small">TRENGTH</span> &amp; S<span class="small">URVIVAL<br/>IN THE</span> C<span class="small">HILEAN</span> M<span class="small">INES</span><br/><br/><br/><br/><br/></p>
<p class="center">J<span class="small">OSÉ</span> H<span class="small">ENRÍQUEZ</span><br/><br/><br/><br/><br/><br/></p>
<p class="center"><img alt="" src="OEBPS/images/zondervan_L01.png"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780310334965_epub_tp_r1.vue?e3933772